export default {
    namespace: 'homepage',
    supportedLocales: [
        'de-de',
        'en-ca',
        'en-gb',
        'en-us',
        'es-es',
        'es-mx',
        'fr-ca',
        'fr-fr',
        'it-it',
        'nl-nl',
    ],
    supportedCurrencies: [
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HRK',
        'HUF',
        'MXN',
        'NOK',
        'PLN',
        'RON',
        'SEK',
        'TRY',
        'USD',
    ],
    defaultLocale: 'en-us',
    defaultCurrency: 'USD',
};
